import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Redirect } from 'react-router-dom';
import renderHTML from 'react-render-html';
import { Fade } from 'react-reveal';
import { Actions } from '../../../flux';
import { images, texts, relacionamentos } from '../../../settings';
import { DelayLink, SliderText } from '../../../components';

import '../Iniciativas.scss';
import './Treinamentos.scss';

class Treinamentos extends Component {
  constructor(props) {
		super(props);

		this.state = {
			selected: 'mulher',
			mobile: (window.innerWidth < 768) ? true : false
		}

		this.contentText = React.createRef();
  }

  scrollTop = () => {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  }

  componentDidMount = () => {
    Actions.headerIntern();
		this.scrollTop();

		// if (this.state.mobile == true) {
		// 	this.mobileNav();
		// }
	}
	
	mobileNav = () => {
	}

	changeItem = () => {
		const { selected } = this.state
		this.setState({
			selected: (selected == 'mulher') ? 'homem' : 'mulher'
		});
	}

  render = () => {
		const { selected } = this.state
    return (
      <div className="views" ref={this.contentText}>
				<Helmet>
					<title>Treinamentos - Iniciativas - {texts.title}</title>
				</Helmet>


				<div className="iniciativas-home treinamentos-home page-gradient page-gradient--yellow bg-gray" ref="treinamentos-home">

					<section className="iniciativas-area page--yellow">
						<div className="container container--large">
							<div className="row">
								<div className="col-12">
									<Fade bottom>
										<div className={`card card--page-body card--light-blue`}>
											<div className="card__content">
												<div className="card__content__header">
													<DelayLink to={`/estrategias/dentro-de-casa`} className="button button--aylen button--gray-500 button--border-medium button--size-m button--round-l button--text-thick">
														Voltar
													</DelayLink>
													<h1 className="title title--gray">
														<span className="gri_text gri_text--fixed">
                              Treinamentos
															<span className="gri_label light-blue">GRI <b>103-1, 103-2, 103-3</b></span>
														</span>
													</h1>
												</div>
												<div className="card__content__body">
												<p>Nossa equipe passou por mais de 7 mil horas de treinamento em 2019, uma média de 23 horas por pessoa. Além dos programas Insiders e No Ar, os funcionários participaram de cursos, workshops, congressos e outros eventos, tanto por iniciativa própria como pela demanda dos gestores por conhecimentos técnicos.</p>
												</div>
											</div>
											
											{/* <div className="card__image">
												<img src={content.image} />
											</div> */}
										</div>
									</Fade>
								</div>
							</div>
						</div>
					</section>

					<section className="iniciativas-body iniciativas-body--treinamentos">

						<div className="container container--large">
							<div className="row">
								
								<div className="col-12">
									<Fade bottom>
										<div className="card card--no-border card--horas">
											<div className="card__content card__content--full">

												<div className="card__content__body">
													<div className="row">
														<div className="col-3">
															<img src={images.iniciativas.treinamentos.mulher} className="mulher img_desk" />
														</div>

														<div className="col-6">
															<h2 className="title title--small dark-gray gri_text gri_text--fixed-right">
																Média de horas de treinamento por cargo e gênero 
																<span className="gri_label light-gray">GRI <b>404-1</b></span>
															</h2>

															<div className="table_header_mobile">
																<div className="table_header_mobile__nav">
																	<div className={`c__nav__button c__nav__button--prev`} onClick={() => this.changeItem()}></div>
																	<div className="c__nav__status">
																		{selected == 'mulher' && <h3>Mulheres</h3>}
																		{selected == 'homem' && <h3>Homens</h3>}
																	</div>
																	<div className={`c__nav__button c__nav__button--next`} onClick={() => this.changeItem()}></div>
																</div>
															</div>

															<table className="table" cellPadding={0} cellSpacing={0}>
																{
																	this.state.mobile == false && 
																	<thead>
																		<tr>
																			<th>Cargo</th>
																			<th>Mulheres</th>
																			<th>Homem</th>
																		</tr>
																	</thead>
																}

																<tbody>
																	<tr>
																		<td>Superintendentes</td>
																		{(this.state.mobile == false || selected == 'mulher') && <td>144,5</td>}
																		{(this.state.mobile == false || selected == 'homem') && <td>33,8</td>}
																	</tr>
																	<tr>
																		<td>Gerentes</td>
																		{(this.state.mobile == false || selected == 'mulher') && <td>31,8</td>}
																		{(this.state.mobile == false || selected == 'homem') && <td>31,0</td>}
																	</tr>
																	<tr>
																		<td>Coordenadores</td>
																		{(this.state.mobile == false || selected == 'mulher') && <td>36,1</td>}
																		{(this.state.mobile == false || selected == 'homem') && <td>61,0</td>}
																	</tr>
																	<tr>
																		<td>Analistas</td>
																		{(this.state.mobile == false || selected == 'mulher') && <td>22,4</td>}
																		{(this.state.mobile == false || selected == 'homem') && <td>20,7</td>}
																	</tr>
																	<tr>
																		<td>Assistentes</td>
																		{(this.state.mobile == false || selected == 'mulher') && <td>13,3</td>}
																		{(this.state.mobile == false || selected == 'homem') && <td>10,0</td>}
																	</tr>
																	<tr>
																		<td>Apoio</td>
																		{(this.state.mobile == false || selected == 'mulher') && <td>14,0</td>}
																		{(this.state.mobile == false || selected == 'homem') && <td>6,0</td>}
																	</tr>
																	<tr>
																		<td>Estagiários</td>
																		{(this.state.mobile == false || selected == 'mulher') && <td>15,3</td>}
																		{(this.state.mobile == false || selected == 'homem') && <td>9,25</td>}
																	</tr>
																	<tr>
																		<td>Jovens aprendizes</td>
																		{(this.state.mobile == false || selected == 'mulher') && <td>6,0</td>}
																		{(this.state.mobile == false || selected == 'homem') && <td>0,0</td>}
																	</tr>
																</tbody>
																<tfoot>
																	<tr>
																		<td>Total</td>
																		{(this.state.mobile == false || selected == 'mulher') && <td>22,9</td>}
																		{(this.state.mobile == false || selected == 'homem') && <td>21,4</td>}
																	</tr>
																</tfoot>
															</table>
														</div>

														<div className="col-3">
															<img src={images.iniciativas.treinamentos.homem} className="homem img_desk" />
														</div>

														<div className="col-12 mobile_images">
															{selected == 'mulher' && <img src={images.iniciativas.treinamentos.homem} className="homem img_mobile" />}
															{selected == 'homem' && <img src={images.iniciativas.treinamentos.mulher} className="mulher img_mobile" />}
														</div>
													</div>
												</div>

											</div>
										</div>
									</Fade>
								</div>

							</div>
						</div>

					</section>

				</div>

      </div>
    );
  }
}

export { Treinamentos };
